import { useQuery } from '@apollo/client';
import { Flex, Text } from 'rebass/styled-components';
import { GET_PRESET_PLAN_COURSES_ANSWERS } from '../../../graphql/queries';
import { IGetPatientMobilePresetPlanCoursesAnswersInput, IGetPatientMobilePresetPlanCoursesAnswersOutput } from '../../../graphql/types/queries/course';
import moment from 'moment';

export const PresetPlanAnswers = ({ courseId, patientId }: { courseId: string; patientId: string; }) => {
  const { data, loading } = useQuery<IGetPatientMobilePresetPlanCoursesAnswersOutput, IGetPatientMobilePresetPlanCoursesAnswersInput>(GET_PRESET_PLAN_COURSES_ANSWERS, {
    variables: {
      courseId,
      patientId: patientId
    }
  });

  if (!!loading || !data) return null;
  if (!data.healthCoachGetPatientMobilePresetPlanAnswers || data.healthCoachGetPatientMobilePresetPlanAnswers.length < 1 || data.healthCoachGetPatientMobilePresetPlanAnswers.filter(xx => {
    if (!xx.buttonClicked && !xx.journaling && !xx.buttonClicked) return false;
    return true;
  }).length < 1) {
    return (<Flex flexDirection={'column'} paddingX={'36px'}>
      <Text opacity={0.7} textAlign={'center'} mb={4}>No Responses Recorded</Text>
    </Flex>);
  }
  return (
    <Flex flexDirection={'column'} paddingX={'36px'}>
      {data.healthCoachGetPatientMobilePresetPlanAnswers.filter(xx => {
        if (!xx.buttonClicked && !xx.journaling && !xx.buttonClicked) return false;
        return true;
      }).map(x => {
        return (
          <Flex mb={3} paddingBottom={3} style={{ borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
            <Text mr={3} width={'25%'}>{x.programCourseScreen?.title}</Text>
            <Flex flexDirection={'column'} flex={1}>
              <Flex>
                <Text mb={3} flex={1}>{x.programCourseScreen?.content}</Text>
                <Text mb={3} ml={3} opacity={0.5} fontSize={'12px'}>{moment(x.date).format('MM/DD/YYYY hh:mma')}</Text>
              </Flex>
              {x.journaling && (
                <Flex flexDirection={'column'}>
                  <Text opacity={0.5}>Journal:</Text>
                  <Text>{x.journaling}</Text>
                </Flex>
              )}
              {x.selectedOptions && x.selectedOptions.length > 0 && (
                <Flex flexDirection={'column'}>
                  <Text opacity={0.5}>Selected Options:</Text>
                  <Text>{x.selectedOptions.join(', ')}</Text>
                </Flex>
              )}
              {x.buttonClicked && (
                <Flex flexDirection={'column'}>
                  <Text opacity={0.5}>Button Clicked:</Text>
                  <Text>{x.buttonClicked}</Text>
                </Flex>
              )}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
